import { createContext } from 'react';
export var AddressFormatterContext = createContext(null);
var AddressFormatterProvider = AddressFormatterContext.Provider;
export default AddressFormatterProvider;
//# sourceMappingURL=AddressFormatterProvider.js.map